import { render, staticRenderFns } from "./ot-formattable-textarea.vue?vue&type=template&id=538d5903&scoped=true&"
import script from "./ot-formattable-textarea.vue?vue&type=script&lang=ts&"
export * from "./ot-formattable-textarea.vue?vue&type=script&lang=ts&"
import style0 from "./ot-formattable-textarea.vue?vue&type=style&index=0&id=538d5903&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d5903",
  null
  
)

export default component.exports